module.exports = __webpack_public_path__ + "img/bdc0f29.jpg";